import { createContext} from 'react';
const StoreContext = createContext({token:null,usr_type:null,per_id:null,year:null,per_std:null,allow:null,per_admin:null,key:null,setUsrType:({usr_type,per_std})=>{}, setAllow:({allow})=>{}, setStd:({per_std})=>{},setToken:({token,usr_type,per_id,year,allow,per_admin})=>{},quitToken:()=>{}}); // Create a context object

export default StoreContext;